import { useEffect, useState, useRef } from "react";
import { AiOutlineMenu, AiOutlineShoppingCart } from "react-icons/ai";
import { BsFillEmojiSmileUpsideDownFill, BsChevronUp } from "react-icons/bs";
import { useSelector } from "react-redux";
import { Link, matchPath, useLocation } from "react-router-dom";

import logo from "../../assets/Logo/Logo-Full-Light.png";
import logoNoBox from "../../assets/Logo/Logo-Full-No-Box.png"

import { NavbarLinks } from "../../data/navbar-links";
import { apiConnector } from "../../services/apiconnector";
import { categories } from "../../services/apis";
import { ACCOUNT_TYPE } from "../../utils/constants";
import ProfileDropdown from "../core/Auth/ProfileDropDown";

import useOnClickOutside from "../../hooks/useOnClickOutside";
import { sidebarLinks } from "../../data/dashboard-links";

import { AnimatePresence, motion } from "framer-motion";

function Navbar() {
  const { token } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.profile);
  const { totalItems } = useSelector((state) => state.cart);
  const location = useLocation();

  const [subLinks, setSubLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await apiConnector("GET", categories.CATEGORIES_API);
        setSubLinks(res.data.data);
      } catch (error) {
        console.log("Could not fetch Categories.", error);
      }
      setLoading(false);
    })();
  }, []);

  // console.log("sub links", subLinks)

  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname);
  };

  return (
    <div
      className={`flex h-14  items-center justify-center border-b-[1px] border-b-richblack-700 z-40  
      bg-nav-background bg-cover
      ${location.pathname !== "/" ? "bg-richblack-800" : "" } transition-all duration-200`}
    >
      <div className="flex w-11/12 max-w-maxContent items-center justify-between ">
        {/* Logo */}
        <Link to="/" className="">
          <img
            src={logoNoBox}
            alt="Logo"
            width={160}
            height={32}
            loading="lazy"
            className=""
          />
        </Link>
        {/* Navigation links */}
        <nav className="hidden md:block">
          <ul className="flex gap-x-6 text-[#f3f6e7]">
            {NavbarLinks.map((link, index) => (
              <li key={index}>
                {link.title === "Catalog" ? (
                  <>
                    <div
                      className={`group relative flex cursor-pointer items-center gap-1 ${
                        matchRoute("/catalog/:catalogName")
                          ? "text-[#0dc6b4]"
                          : "text-[#f3f6e7]"
                      }`}
                    >
                      <p>{link.title}</p>
                      <BsFillEmojiSmileUpsideDownFill
                        className={` ${
                          matchRoute("/catalog/:catalogName")
                            ? "rotate-180"
                            : ""
                        } group-hover:rotate-180 transition-all duration-300`}
                      />

                      <div
                        className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg
                       bg-[#f3f6e7] p-4 text-richblack-900 opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]"
                      >
                        <div
                          className="absolute left-[50%] top-0 -z-10 h-6 w-6 translate-x-[80%]
                         translate-y-[-40%] rotate-45 select-none rounded bg-[#f3f6e7]"
                        ></div>
                        {loading ? (
                          <p className="text-center">Loading...</p>
                        ) : subLinks?.length ? (
                          <>
                            {subLinks
                              ?.filter(
                                (subLink) => subLink?.courses?.length > 0
                              )
                              ?.map((subLink, i) => (
                                <Link
                                  to={`/catalog/${subLink.name
                                    .split(" ")
                                    .join("-")
                                    .toLowerCase()}`}
                                  className="rounded-lg bg-transparent py-4 pl-4 hover:bg-[#06c6b4]"
                                  key={i}
                                >
                                  <p>{subLink.name}</p>
                                </Link>
                              ))}
                          </>
                        ) : (
                          <p className="text-center">No Courses Found</p>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <Link to={link?.path}>
                    <p
                      className={`${
                        matchRoute(link?.path)
                          ? "text-[#0dc6b4]"
                          : "text-[#f3f6e7]"
                      }`}
                    >
                      {link.title}
                    </p>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
        {/* Login / Signup /cart*/}

        <div className="flex flex-row gap-8">
          <div className="hidden items-center gap-4 md:flex md:self">
            {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
              <Link to="/dashboard/cart" className="relative">
                <AiOutlineShoppingCart className="text-2xl text-[#f3f6e7]" />
                {totalItems > 0 && (
                  <span className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-[#0dc6b4]">
                    {totalItems}
                  </span>
                )}
              </Link>
            )}
            {token === null && (
              <Link to="/login">
                <button
                  className="rounded-[8px] border border-richblack-700 bg-[#161d29e5] px-[12px] py-[8px] text-[#f3f6e7]
                  hover:shadow-none active:shadow-none shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] hover:scale-95 active:scale-95 transition-all duration-200 "
                >
                  Log in
                </button>
              </Link>
            )}
            {token === null && (
              <Link to="/signup">
                <button
                  className="rounded-[8px] border border-richblack-700 bg-[#161d29e5] px-[12px] py-[8px] text-[#f3f6e7]
                hover:shadow-none active:shadow-none shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] hover:scale-95 
                active:scale-95 transition-all duration-200 
                "
                >
                  Sign up
                </button>
              </Link>
            )}
          </div>

          <div className="flex flex-row items-center gap-x-4 justify-end">
            <button
              className="mr-4 md:hidden"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <AiOutlineMenu
                fontSize={24}
                className={`${open ? "text-[#f3f6e7]" : "text-richblack-600"}
              transition-colors duration-300`}
              />
            </button>

            {token !== null && <ProfileDropdown />}
          </div>
        </div>


        <AnimatePresence>
          {open && (
            <NavBarForSmallDisplay
              // onClick={(e) => e.stopPropagation()}
              setOpen={setOpen}
              NavbarLinks={NavbarLinks}
              token={token}
              subLinks={subLinks}
              matchRoute={matchRoute}
              loading={loading}
              user={user}
              totalItems={totalItems}
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

const NavBarForSmallDisplay = ({
  NavbarLinks,
  loading,
  subLinks,
  matchRoute,
  token,
  setOpen,
  user,
  totalItems,
}) => {
  const ref = useRef(null);
  useOnClickOutside(ref, () => setOpen(false));
  const [viewSublink, serViewSublink] = useState(false);


  //navbar_animation


  return (
    <motion.div
      onClick={(e) => e.stopPropagation()}
      initial={{x:-60}}
      
      animate={{x:0}}
      

      ref={ref}
      className={`fixed md:hidden min-w-[50vw] min-h-[100vh] 
      top-0 left-0 bg-richblack-500 text-[#f3f6e7] flex flex-col justify-start items-start
      backdrop-blur-md bg-opacity-40 
     `}
    >
      <div className="p-4 pl-4 ">
        <div className="mb-4">
          <img src={logo} alt="Logo" width={160} height={32} loading="lazy" />
        </div>
        <ul className="flex flex-col gap-4 text-lg font-semibold">
          {NavbarLinks.map((link, index) => (
            <li key={index}>
              {link.title === "Catalog" ? (
                <div
                  onClick={() => {
                    serViewSublink(!viewSublink);
                  }}
                  className=""
                >
                  <div className="flex flex-col gap-4 group ">
                    <div className="peer flex flex-row items-center gap-2  group-hover:text-[#0dc6b4]  transition-all duration-200">
                      <p>{link.title}</p>
                      <BsFillEmojiSmileUpsideDownFill
                        className={`${
                          viewSublink ? "rotate-180" : ""
                        } transition-all duration-200 group-hover:text-[#0dc6b4] `}
                      />
                    </div>

                    {viewSublink && (
                      <div className={` transition-all duration-500`}>
                        {loading ? (
                          <p className="text-center">Loading...</p>
                        ) : subLinks?.length ? (
                          <div className="flex flex-col gap-2 pl-4">
                            {subLinks
                              ?.filter(
                                (subLink) => subLink?.courses?.length > 0
                              )
                              ?.map((subLink, i) => (
                                <Link
                                  to={`/catalog/${subLink.name
                                    .split(" ")
                                    .join("-")
                                    .toLowerCase()}`}
                                  key={i}
                                  onClick={() => {
                                    setOpen(false);
                                  }}
                                  className=" hover:text-[#0dc6b4] transition-all duration-200"
                                >
                                  <p>{subLink.name}</p>
                                </Link>
                              ))}
                          </div>
                        ) : (
                          <p className="text-center">No Courses Found</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <Link
                  to={link?.path}
                  onClick={() => {
                    setOpen(false);
                  }}
                  className=" hover:text-[#0dc6b4] transition-all duration-200"
                >
                  <p>{link.title}</p>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div
        className="p-4 pl-4"
        onClick={() => {
          setOpen(false);
        }}
      >
        {user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
          <Link
            to="/dashboard/cart"
            className="relative  hover:text-[#0dc6b4] group"
          >
            <div className="flex flex-row gap-2 text-xl font-semibold ">
              <p>Cart</p>
              <AiOutlineShoppingCart className="text-2xl group-hover:text-[#0dc6b4]  text-[#f3f6e7] transition-all duration-200" />
            </div>
            {totalItems > 0 && (
              <span
                className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center
               overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-[#0dc6b4] transition-all duration-200"
              >
                {totalItems}
              </span>
            )}
          </Link>
        )}
        <div
          className="flex flex-col text-xl gap-2 font-semibold
        bg-gradient-to-b from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text "
        >
          {token === null && (
            <Link to="/login">
              <button>Log in</button>
            </Link>
          )}
          {token === null && (
            <Link to="/signup">
              <button>Sign up</button>
            </Link>
          )}
        </div>
      </div>

      {token !== null && (
        <div className="p-4 pl-4 flex flex-col gap-2 text-lg font-semibold ">
          <>
            {sidebarLinks.map((link) => {
              if (
                (link.type && user?.accountType !== link.type) ||
                link.path.split("/").reverse()[0] === "cart"
              )
                return null;
              return (
                <div key={link.id}>
                  <Link
                    to={link.path}
                    onClick={() => {
                      setOpen(false);
                    }}
                    className=" hover:text-[#0dc6b4] transition-all duration-200"
                  >
                    {link.name}
                  </Link>
                </div>
              );
            })}
          </>
          <Link
            to="dashboard/settings"
            onClick={() => {
              setOpen(false);
            }}
            className=" hover:text-[#0dc6b4] transition-all duration-200"
          >
            Settings
          </Link>
        </div>
      )}
      {token != null && (
        <p
          className={`place-content-end p-4 text-richblack-500 lowercase
         ${user?.accountType === "Instructor" ? "mt-48" : "mt-56"}`}
        >
          @{user?.accountType}
        </p>
      )}
    </motion.div>
  );
};

export default Navbar;
